<template>
    <div class="float-left mr-1">
        <span :class="`text-${cor}`">
            <i
                :class="`fa ${icone} fa-lg icon-button`"
                :title="titulo"
                @click.stop="exibirRateio()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String,
            default: () => 'Rateios'
        },

        icone: {
            type: String,
            default: () => 'fa-pie-chart'
        },

        cor: {
            type: String,
            default: () => 'primary'
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        exibirRateio() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterComprometimento(
                    this.$route.params.contratoId,
                    this.comprometimento.idComprometimentoRequisicao
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit(
                                'atualizarComprometimento',
                                response.data
                            )
                        } else {
                            this.$toast.error(
                                'Erro ao obter o comprometimento',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
